import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import React from "react";
import { IErrorCauseDto } from "../../models/ErrorCauseDto";
import './ErrorDialog.css';

interface Column {
    id: 'nRow' | 'column' | 'cause';
    label: string;
    minWidth?: number;
    maxWidth?: number;
    align?: 'left';
}

export class ErrorDialog extends React.Component<any, any> {
    columns: Column[] = [
        { id: 'nRow', label: 'Riga', minWidth: 120 },
        { id: 'column', label: 'Colonna', minWidth: 190 },
        { id: 'cause', label: 'Tipologia di errore', minWidth: 640 }
    ];

    render(){
        return (
            this.props.show ?
            <Dialog
                    id={"error-dialog"}
                    open={this.props.show}
                    onClose={this.props.onClose}
                    maxWidth={"xl"}
            >
                 <DialogTitle id={"error-dialog-title"}>Dettaglio errori</DialogTitle>
                 <DialogContent id={"error-dialog-content"}>
                     <DialogContentText>
                     <TableContainer style={{maxHeight: '300px', maxWidth: '950px'}}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    {this.columns.map((column) => (
                                        <TableCell
                                            className={"error-dialog-th"}
                                            key={column.id}
                                            align={column.align}
                                            style={{ minWidth: column.minWidth, maxWidth: column.maxWidth }}
                                            >
                                            {column.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {this.props.errors.map((error: IErrorCauseDto, index: number) => {
                            return (
                                <TableRow tabIndex={-1} key={index}>
                                    {this.columns.map((column) => {
                                        const value = error[column.id];
                                        return (
                                        <TableCell key={column.id} align={column.align} className={"error-dialog-td"}>
                                            {value}
                                        </TableCell>
                                        );
                                    })}
                                </TableRow>
                                );
                            })}
                        </TableBody>
                        </Table>
                    </TableContainer>
                     </DialogContentText>
                </DialogContent>
                <DialogActions className={"error-dialog-actions"}>
                    <Button id={"error-dialog-button"} onClick={this.props.onClose}>
                        {"OK, CAPITO".toUpperCase()}
                    </Button>
                </DialogActions>
            </Dialog> : null
        )
    }
}